import * as React from 'react';
import {DisplayFeatureType, DisplayFeature} from "../../contract-features-3/domain";
import AssociationElement from "./AssociationElement";
import {AssociatedFeature} from "../domain/AssociatedFeature";
import {Definition} from "../domain/Definition";
import classNames from 'classnames';
import {DisAssociate, ReAssociate} from "../../../actions/actions";
import {FeatureTypeSummary} from "../../../../integration/representation/feature-type";

interface FeatureTypeProps {
    featureType: FeatureTypeSummary;
    associationElements:  AssociatedFeature[];
    selectedFeatureType: DisplayFeatureType;
    associationClickHandler: (association: AssociatedFeature) => void;
    selectedFeature: DisplayFeature;
    selectedAssociation: AssociatedFeature;
    disAssociateHandler: DisAssociate;
    reAssociateHandler: ReAssociate;
    attributePopoverData: Definition[];
    disableDescriptiveName: boolean;
}
class FeatureTypeComponent extends React.Component<FeatureTypeProps, {expanded: Boolean}> {

    constructor(props: FeatureTypeProps) {
        super(props);

        this.state = {
            expanded: false
        }
    }

    toggleExpanded(){
        this.setState({expanded: !this.state.expanded});
    }

    render(){
        const {
            featureType,
            selectedFeatureType,
            associationElements,
            associationClickHandler,
            selectedFeature,
            selectedAssociation,
            disAssociateHandler,
            reAssociateHandler,
            attributePopoverData,
            disableDescriptiveName,
        } = this.props;

        const isSelected = selectedFeatureType && selectedFeatureType.typeId === featureType.typeid;

        const classes = classNames({
            'selected' : isSelected,
            'expanded' : this.state.expanded,
            'featuretype': true
        });


        if (!associationElements.length) {
            return null;
        }

        return (

            <div className={classes}>
                <div className="featureinfo text-bold text-black" onClick={() => this.toggleExpanded()}>
                    <h3>
                        <span className="color-mid-gray">{featureType.typeid}</span>&nbsp;{featureType.name}
                    </h3>
                </div>
                {
                    this.state.expanded &&
                    <div className="childList open">
                        {associationElements.map(assoc => {
                            return (
                                <AssociationElement
                                    key={assoc.id}
                                    association={assoc}
                                    selectHandler={associationClickHandler}
                                    selectedFeature={selectedFeature}
                                    selectedAssociation={selectedAssociation}
                                    disAssociateHandler={disAssociateHandler}
                                    reAssociateHandler={reAssociateHandler}
                                    attributePopoverData={attributePopoverData}
                                    disableDescriptiveName={disableDescriptiveName}
                                />
                            )
                        })}
                    </div>
                }
            </div>

        )
    }
}


export default FeatureTypeComponent;